import { Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect } from 'react';
import { trackPromise } from "react-promise-tracker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { onError } from 'src/store/actions/popupActions';
import axios from "../../axios/AxiosInterceptors";
import { SET_GENERATOR_LIST } from "../../store/GeneratorManagement/GeneratorManagementActionTypes";
import useStyles from "../../Styles";

const GeneratorList = (props) => {

    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const generators = useSelector(state => state.generatorManagement.generators)

    useEffect(() => {
        retrieveGenerators();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    const retrieveGenerators = async () => {
        await trackPromise(axios.get("/account-service/v1/account/" + params.accountId + "/generator").then(response => {
            if (response.data) {
                dispatch({ type: SET_GENERATOR_LIST, generators: response.data });
            }
        }).catch(error => {
            dispatch(onError(error.response));
        }))
    }

    const onClick = (id) => {
        history.push("/generator-management/account/" + params.accountId + "/generator/" + id);
    }

    return (
        <main className={classes.layout}>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button onClick={() => history.push("/generator-management/account/" + params.accountId + "/generator/create")}>Create Generator</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Queue Number</TableCell>
                            <TableCell>Generator Name</TableCell>
                            <TableCell>MFO</TableCell>
                            <TableCell>TO Zone</TableCell>
                            <TableCell>PNode ID</TableCell>
                            <TableCell>PNode Name</TableCell>
                            <TableCell>Power Meter ID</TableCell>
                            <TableCell>Markets Gateway ID</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {generators && generators.length > 0 && generators.map(r => {
                            return (
                                <TableRow onClick={(id) => onClick(r.id)} key={r.id} className={classes.tableRow}>
                                    <TableCell>{r.queueNumber}</TableCell>
                                    <TableCell>{r.generatorName}</TableCell>
                                    <TableCell>{r.mfo}</TableCell>
                                    <TableCell>{r.toZone}</TableCell>
                                    <TableCell>{r.pnodeId}</TableCell>
                                    <TableCell>{r.pnodeName}</TableCell>
                                    <TableCell>{r.powerMeterId}</TableCell>
                                    <TableCell>{r.marketsGatewayId}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </main>
    )

}

export default GeneratorList;